import * as ActionTypes from './actionTypes'

export const initializeDropDownValues=(payload) =>{
    return {
        type: ActionTypes.INITIALIZE_DROPDOWNS,
        payload
    }
}

